export const securityKey = {
    EMPLOYERSSEARCH: "Employers Search",

    EMPLOYERPAGE: "Employer Page",
    ADDEMPLOYER: "Add Employer",
    EDITEMPLOYER: "Edit Employer",
    DELETEEMPLOYER: "Delete Employer",

    // EMPLOYER TABS
    // Audit
    ADDEMPLOYERAUDIT: "Add Employer Audit",
    EDITEMPLOYERAUDIT: "Edit Employer Audit",
    DELETEEMPLOYERAUDIT: "Delete Employer Audit",

    // Bankruptcy
    EDITEMPLOYERBANKRUPTCY: "Edit Employer Bankruptcy",

    // Comments
    ADDEMPLOYERCOMMENTS: "Add Employer Comments",
    EDITEMPLOYERCOMMENTS: "Edit Employer Comments",
    DELETEEMPLOYERCOMMENTS: "Delete Employer Comments",

    // Employer Contracts
    ADDEMPLOYERCONTRACTS: "Add Employer Contracts",
    EDITEMPLOYERCONTRACTS: "Edit Employer Contracts",
    DELETEEMPLOYERCONTRACTS: "Delete Employer Contracts",
    
    // Employer Associations
    ADDEMPLOYERASSOCIATIONS: "Add Employer Associations",
    EDITEMPLOYERASSOCIATIONS: "Edit Employer Associations",
    DELETEEMPLOYERASSOCIATIONS: "Delete Employer Associations",

    // Bonds
    ADDEMPLOYERBONDS: "Add Employer Bonds",
    EDITEMPLOYERBONDS: "Edit Employer Bonds",
    DELETEEMPLOYERBONDS: "Delete Employer Bonds",

    // Contracts
    CONTRACTS: "Contracts",
    ADDCONTRACTS: "Add Contracts",
    EDITCONTRACTS: "Edit Contracts",
    DELETECONTRACTS: "Delete Contracts",

    // Associations
    ASSOCIATIONS: "Associations",
    ADDASSOCIATIONS: "Add Associations",
    EDITASSOCIATIONS: "Edit Associations",
    DELETEASSOCIATIONS: "Delete Associations",

    // Cancellation
    ADDEMPLOYERCANCELLATION: "Add Employer Cancellation",
    EDITEMPLOYERCANCELLATION: "Edit Employer Cancellation",
    //DELETEEMPLOYERCANCELLATION: "Delete Employer Cancellation",
    
  
    //Employer project Contract
    ADDEMPLOYERPROJECTCONTRACT: "Add Employer Project Contract",
    // EDITEMPLOYERPROJECTCONTRACT: "Edit Employer Project Contract",


    REPORTS: "Reports",
    EMPLOYERLIST: "Employer List",
    CONTRACTBYCRAFTREPORT: "Contract By Craft Report",
    EMPLOYERDEMOGRAPHICREPORT: "Employer Demographic Report",
    CONTRACTSBYASSOCIATIONREPORT: "Contracts By Association Report",
    UNSIGNEDEMPLOYERS: "Unsigned Employers",
    BONDREPORT: "Bond Report",
    CONTRACTORBYSIGNDATE: "Contractor By Sign Date",
    SECURITY: "Security",

    PERMISSIONS: "Permissions",
    ADDPERMISSIONS: "Add Permissions",

    //TODO : KP Need to check for the below keys.
    USERMANAGEMENT: "User Management",
    ADDUSER: "Add User",
    EDITUSER: "Edit User",
    DELETEUSER: "Delete User",

    SECURITYGROUPMANAGEMENT: "Security Group Management",
    ADDSECURITYGROUP: "Add Group",
    EDITSECURITYGROUP: "Edit Group",
    DELETESECURITYGROUP: "Delete Group",

    UTILITIES: "Utilities",

    CRAFTS: "Crafts",
    ADDCRAFTS: "Add Crafts",
    EDITCRAFTS: "Edit Crafts",
    DELETECRAFTS: "Delete Crafts",

    LOCALS: "Locals",
    ADDLOCALS: "Add Locals",
    EDITLOCALS: "Edit Locals",
    DELETELOCALS: "Delete Locals",

    CONTRACTORWORKTYPES: "Contractor Work Types",
    ADDCONTRACTORWORKTYPES: "Add Contractor Work Types",
    EDITCONTRACTORWORKTYPES: "Edit Contractor Work Types",
    DELETECONTRACTORWORKTYPES: "Delete Contractor Work Types",

    EMPLOYERTYPES: "Employer Types",
    ADDEMPLOYERTYPES: "Add Employer Types",
    EDITEMPLOYERTYPES: "Edit Employer Types",
    DELETEEMPLOYERTYPES: "Delete Employer Types",

    CONTRACTTYPES: "Contract Types",
    ADDCONTRACTTYPES: "Add Contract Types",
    EDITCONTRACTTYPES: "Edit Contract Types",
    DELETECONTRACTTYPES: "Delete Contract Types",

    EMPLOYERMERGE: "EmployerMerge",
};